import { _cleanSearchArguments } from './_cleanSearchArguments';

/**
  function que busca si existe el conjunto de letras (query) en una cadena (string) en el mismo orden
  Es tipo la busqueda con <Ctrl+P> del <Chrome Dev Tool>
  
  @param string string - la cadena
  @param string query - los caracteres a buscar
  @param object opciones

  @return boolean true si encuentra todos los carateres de la query
 */

export function filter(...args) {
  const { string = '', query = '', options = {} } = _cleanSearchArguments.apply(null, args);
  if (!string) {
    return false;
  }
  if (!query) {
    return true;
  }

  const array = query.split('');
  let acc = string;

  for (let i = 0, len = array.length; i < len; i++) {
    const cur = array.shift();
    const position = acc.indexOf(cur);
    if (position === -1) {
      return false;
    }
    acc = acc.substr(position + 1);
  }
  return true;
}
